/**
 * ProviderSidebar
 * Navigation sidebar for the provider portal.
 */
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

const NAV_ITEMS = [
  { to: '/', label: 'Dashboard', icon: '\u2302' },
  { to: '/leads', label: 'Leads', icon: '\u2709' },
  { to: '/subscription', label: 'Subscription', icon: '\u2606' },
  { to: '/featured', label: 'Featured Listings', icon: '\u2726' },
  { to: '/profile', label: 'Profile', icon: '\u263A' },
  { to: '/analytics', label: 'Analytics', icon: '\u2261' },
  { to: '/reviews', label: 'Reviews', icon: '\u2605' },
  { to: '/api-access', label: 'API Access', icon: '\u27A4' },
  { to: '/engagement', label: 'User Engagement', icon: '\u2764' },
  { to: '/portfolio', label: 'Portfolio', icon: '\u2736' },
  { to: '/integrations', label: 'Integrations', icon: '\u2699' },
  { to: '/alert-insights', label: 'Alert Insights', icon: '\u2691' },
  { to: '/compliance-reports', label: 'Compliance', icon: '\u2611' },
  { to: '/disputes', label: 'Disputes', icon: '\u2696' },
  { to: '/analytics-overview', label: 'Analytics Overview', icon: '\u25F4' },
  { to: '/traffic', label: 'Traffic', icon: '\u2197' },
  { to: '/market-insights', label: 'Market Insights', icon: '\u25C8' },
  { to: '/performance-benchmark', label: 'Benchmark', icon: '\u25B2' },
  { to: '/contact-requests', label: 'Contact Requests', icon: '\u260E' },
  { to: '/support', label: 'Support', icon: '\u263F' },
];

export default function ProviderSidebar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('provider_token');
    navigate('/login');
  };

  return (
    <aside
      style={{
        width: '240px',
        minWidth: '240px',
        height: '100vh',
        backgroundColor: '#1e293b',
        color: '#e2e8f0',
        display: 'flex',
        flexDirection: 'column',
        position: 'sticky',
        top: 0,
        overflowY: 'auto',
      }}
    >
      {/* Logo / Brand */}
      <div style={{
        padding: '24px 20px 20px',
        borderBottom: '1px solid #334155',
      }}>
        <div style={{ fontSize: '18px', fontWeight: '700', color: '#fff' }}>
          SM-Compare
        </div>
        <div style={{ fontSize: '12px', color: '#94a3b8', marginTop: '2px' }}>
          Provider Dashboard
        </div>
      </div>

      {/* Navigation */}
      <nav style={{ flex: 1, padding: '12px 0' }}>
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            style={({ isActive }) => ({
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              padding: '10px 20px',
              fontSize: '14px',
              fontWeight: isActive ? '600' : '400',
              color: isActive ? '#fff' : '#94a3b8',
              backgroundColor: isActive ? '#334155' : 'transparent',
              borderLeft: isActive ? '3px solid #3b82f6' : '3px solid transparent',
              textDecoration: 'none',
              transition: 'background-color 0.15s, color 0.15s',
            })}
          >
            <span style={{ fontSize: '16px', width: '20px', textAlign: 'center' }}>{item.icon}</span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Logout */}
      <div style={{ padding: '16px 20px', borderTop: '1px solid #334155' }}>
        <button
          onClick={handleLogout}
          type="button"
          style={{
            width: '100%',
            padding: '10px',
            fontSize: '13px',
            fontWeight: '600',
            backgroundColor: 'transparent',
            color: '#94a3b8',
            border: '1px solid #475569',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'background-color 0.15s',
          }}
        >
          Sign Out
        </button>
      </div>
    </aside>
  );
}
